// extracted by mini-css-extract-plugin
export default {"item":"_1tLVTBkoSwOoFj6lx1tf3z"};